module.exports = __webpack_public_path__ + "static/media/screenshot_checklist.1446ea9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshot_checklist.png
// module id = 87
// module chunks = 0